/**
 * Dane osobowe z formularza, wysyłane WYŁĄCZNIE do naszego backendu (za logowaniem).
 * Backend zamienia je na tokeny przed wywołaniem dostawcy LLM (src/api/services/pseudonymizedCall.ts).
 * Pole `pii` jest WYMAGANE przez backend (brak = 400 `pii_required`), nawet puste `{}`.
 */
export interface AIPii {
  child_name?: string;
  birth_date?: string;
  exam_date?: string;
  institution?: string;
  examiner?: string;
}

interface PatientFormFields {
  name?: string;
  birthDate?: string;
  testDate?: string;
  institution?: string;
  examiner?: string;
}

/** Buduje `pii` z formularza pacjenta (legacy `/` i `/new`); puste pola są pomijane. */
export function buildPii(info: PatientFormFields): AIPii {
  const pairs: Array<[keyof AIPii, string | undefined]> = [
    ['child_name', info.name],
    ['birth_date', info.birthDate],
    ['exam_date', info.testDate],
    ['institution', info.institution],
    ['examiner', info.examiner],
  ];
  const out: AIPii = {};
  for (const [key, value] of pairs) {
    if (typeof value === 'string' && value.trim() !== '') out[key] = value.trim();
  }
  return out;
}
